import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoMatrizMarcoLogicoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoMatrizMarcoLogicoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoMatrizMarcoLogicoService(): Observable<
    BodyListResponse<ProyectoMatrizMarcoLogicoDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoMatrizMarcoLogicoDTO>>(
      API_URL + '/api/v1/proyectoMatrizMarcoLogico/todos',
    );
  }

  guardarProyectoMatrizMarcoLogicoService(
    proyectoMatrizMarcoLogicoDTO: ProyectoMatrizMarcoLogicoDTO,
  ): Observable<BodyResponse<ProyectoMatrizMarcoLogicoDTO>> {
    return this.http.post<BodyResponse<ProyectoMatrizMarcoLogicoDTO>>(
      API_URL + '/api/v1/proyectoMatrizMarcoLogico',
      proyectoMatrizMarcoLogicoDTO,
    );
  }

  getProyectoMatrizMarcoLogicoPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoMatrizMarcoLogicoDTO>> {
    return this.http.get<BodyResponse<ProyectoMatrizMarcoLogicoDTO>>(
      API_URL + '/api/v1/proyectoMatrizMarcoLogico/' + codigo,
    );
  }
}
